<div class="search-bar-container">
  <div class="indication-icon"
    [ngClass]="{'accessible': accessibilityMode, 'clear-btn': isSearching}"
    [attr.tabindex]="isSearching ? 0 : -1"
    [attr.role]="isSearching ? 'button' : 'none'"
    (viUiAccessibleClick)="handleIconClicked()">
    <i [ngClass]="{'i-vi-search': !isSearching, 'i-vi-close-small': isSearching }">
    </i>
  </div>
  <vi-ui-composable-input #input
    [messages]="messages"
    [placeholder]="placeholder"
    (messagesChange)="handleMessagesChange($event)"
    (componentDeleted)="handleComponentDeleted($event)"
    (currentFocused)="handleCurrentFocused($event)"
    (keyup.enter)="handleSearchClicked($event)">
  </vi-ui-composable-input>
</div>
@if(isSearching) {
<div class="search-btn"
  [ngClass]="{'accessible': accessibilityMode}"
  role="button"
  tabindex="0"
  (viUiAccessibleClick)="handleSearchClicked()">
  <i class="i-vi-search">
  </i>
</div>
}
